
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class JournalGrid extends _Ext.GridBase<JournalRow, any> {
        protected getColumnsKey() { return 'Finance.Journal'; }
        protected getDialogType() { return JournalDialog; }
        protected getIdProperty() { return JournalRow.idProperty; }
        protected getInsertPermission() { return JournalRow.insertPermission; }
        protected getLocalTextPrefix() { return JournalRow.localTextPrefix; }
        protected getService() { return JournalService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date(); 
            var userDefinition = Q.Authorization.userDefinition;
            var voucherNo = FormatHelper.GetVoucherNo(6);

            this.editItem(<JournalRow>{
                VoucherNo: voucherNo,
                TransDate: now.toString(),
                CreatedBy: userDefinition.UserId,
                VoucherTypeId: 6,
                FinancialYearId: userDefinition.FinancialYearId,
                CompanyId: userDefinition.CompanyId

            });
        }
    }
}